/* MIT License
 *
 * Copyright (c) 2023 Mike Chambers
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import React from "react";

import MedalHighlights from "./GoldMedalSummaryView";
import StatDetails from "./PlayerStatsView";
import PlayerHighlightsView from "./PlayerHighlightsView";

import PlayerOverviewBackgroundImage from "../images/player_overview_background.png";
import DurationView from "../../../components/DurationView";

const elementStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",

    backgroundImage: `url(${PlayerOverviewBackgroundImage})`,
    backgroundRepeat: "repeat",
    borderRadius: "var(--radius-border)",
    rowGap: "36px",
    width: "min-content",
    padding: "var(--padding-content)",
};

const PlayerPerformanceSummaryView = (props) => {
    const summary = props.summary;
    const medals = props.medals;

    return (
        <div style={elementStyle}>
            <PlayerHighlightsView summary={summary} />
            <StatDetails summary={summary} />
            <MedalHighlights medals={medals} />
            <DurationView duration={summary.timePlayedSeconds * 1000} />
        </div>
    );
};

export default PlayerPerformanceSummaryView;
